import partial from 'lodash/partial';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import { getProject } from 'project/ducks/project';
import { getProjectIdFromUrl } from 'project/utils';
import { updateNDA } from 'project/ducks/ndas';
import AccessTypeAction from 'project/components/access_type_action';

function mapStateToProps(state, { requestAccepted }) {
  const project = getProject(state);

  return {
    /* can only deny request in elite projects if not accepted already */
    canDeny: project.elite_only? requestAccepted === null : true
  };
}

export function mapDispatchToProps(dispatch, { params, ndaId }) {
  const projectId = params.projectId || getProjectIdFromUrl(params);

  return bindActionCreators({
    approve: partial(updateNDA, projectId, ndaId, { request_accepted: true }),
    deny: partial(updateNDA, projectId, ndaId, { request_accepted: false }),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccessTypeAction));



// WEBPACK FOOTER //
// ./project/containers/access_type_action.js